import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Box,
  Select,
  Button,
  MenuItem,
  TextField,
  IconButton,
  Typography,
  FormControl,
  InputAdornment,
} from "@mui/material";
import "../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
import { CREATE_CUSTOMER, UPDATE_CUSTOMER } from "../../Schema/Customer";
import { useMutation, useQuery } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function CustomerForm({ open, handleClose, setRefetch, title, editData }) {

  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createCustomerOfGeneralInvoice] = useMutation(CREATE_CUSTOMER, {
    onCompleted: ({ createCustomerOfGeneralInvoice }) => {
      setLoading(false);
      if (createCustomerOfGeneralInvoice?.status === true) {
        setAlert(true, "success", createCustomerOfGeneralInvoice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createCustomerOfGeneralInvoice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
    },
  });


  const [updateCustomerOfGeneralInvoice] = useMutation(UPDATE_CUSTOMER, {
    onCompleted: ({ updateCustomerOfGeneralInvoice }) => {
      setLoading(false);
      if (updateCustomerOfGeneralInvoice?.status === true) {
        setAlert(true, "success", updateCustomerOfGeneralInvoice?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateCustomerOfGeneralInvoice?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
    },
  });

  //fromik
  const Validate = Yup.object().shape({
    note: Yup.string(),
    email: Yup.string(),
    phone: Yup.string(),
    gender: Yup.string(),
    address: Yup.string(),
    companyName: Yup.string(),
    customerNameLatin: Yup.string(),
    customerNameKhmer: Yup.string().required("require!"),
  });

  const formik = useFormik({
    initialValues: {
      note: "",
      email: "",
      phone: "",
      address: "",
      gender: "Male",
      companyName: "",
      customerNameLatin: "",
      customerNameKhmer: "",
    },
    validationSchema: Validate,
    onSubmit: async (values) => {

      if (title === "Create") {
        setLoading(true);
        createCustomerOfGeneralInvoice({
          variables: {
            input: {
              ...values,
            }
          },
        });
      }

      if (title === "Update") {
        setLoading(true);
        updateCustomerOfGeneralInvoice({
          variables: {
            updateCustomerOfGeneralInvoiceId: editData?._id,
            input: {
              ...values,
            }
          },
        });
      }
    },
  });

  const {
    errors,
    values,
    touched,
    resetForm,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;

  useEffect(() => {
    if (open && title === "Create") resetForm();

    if (editData) {
      setFieldValue("note", editData?.note);
      setFieldValue("email", editData?.email);
      setFieldValue("phone", editData?.phone);
      setFieldValue("gender", editData?.gender);
      setFieldValue("address", editData?.address);
      setFieldValue("companyName", editData?.companyName);
      setFieldValue("customerNameLatin", editData?.customerNameLatin);
      setFieldValue("customerNameKhmer", editData?.customerNameKhmer);
    }
  }, [open, editData])
  return (
    <Dialog open={open} className="dialog-container" maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">{title} Customer</Typography>
          </Stack>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <BiMinusCircle className="close-icon" />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={12}>
                <Typography className="field-title">Company Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("companyName")}
                  error={Boolean(touched.companyName && errors.companyName)}
                  helperText={touched.companyName && errors.companyName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">Full Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("customerNameKhmer")}
                  error={Boolean(touched.customerNameKhmer && errors.customerNameKhmer)}
                  helperText={touched.customerNameKhmer && errors.customerNameKhmer}
                />
              </Grid>


              <Grid item xs={6}>
                <Typography className="field-title">Latin Name</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("customerNameLatin")}
                  error={Boolean(touched.customerNameLatin && errors.customerNameLatin)}
                  helperText={touched.customerNameLatin && errors.customerNameLatin}
                />
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography className="field-title"> Gender </Typography>
                <FormControl className="text-field" fullWidth size="small" >
                  <Select
                    value={values?.gender}
                    onChange={(e) => setFieldValue("gender", e?.target?.value)}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">Phone Number</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("phone")}
                  error={Boolean(touched.phone && errors.phone)}
                  helperText={touched.phone && errors.phone}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Email</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("email")}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Address</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("address")}
                  error={Boolean(touched.address && errors.address)}
                  helperText={touched.address && errors.address}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">Note</Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  {...getFieldProps("note")}
                  error={Boolean(touched.note && errors.note)}
                  helperText={touched.note && errors.note}
                />
              </Grid>
              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {title}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
